<template lang="html">
  <div class="content-item-message">
    <!-- <img class="avater" v-if="user.avatar" v-lazy="`${user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`" /> -->
    <img class="avater" v-if="user.avatar" v-lazy="`${user.real_avatar!=='null' && user.real_avatar!=='' ? user.real_avatar:user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"/>
    <img class="avater" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/>
    <div class="content-item-body">
      <div class="content-item">
        <h2>{{user.fullname !== '' && user.fullname !=='null' ? user.fullname : user.nickName}}</h2>
        <!-- <div class="content-item-right" @click.stop="thumbsUp">
            <img v-if="isUp" src="../assets/images/dynamic/thumbs-up-black.svg" />
            <img v-else src="../assets/images/dynamic/thumbs-up-white.svg" />
            <span>{{upCount ? upCount : ''}}</span>
          </div> -->
          <ThumbUpItem @click="thumbsUp" v-bind="getThumbUp" />
      </div>
      <h5>{{getShowTime(createTime)}}</h5>
      <span v-if="parentCommentId" class="desc">回复<span class="parent">@{{parentNickName}}：</span>{{content}}</span>
      <span v-else class="desc">{{content}}</span>
    </div>
  </div>
</template>
<script>
import { getBeforeTimeStr } from '../../../utils/date'
import { post } from '../../../utils/request'
import { get } from '../../../utils/token'
import ThumbUpItem from '../../../components/thunmbUpItem'
export default {
  components: {
    ThumbUpItem
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    parentCommentId: {
      type: Number,
      default: 0
    },
    parentNickName: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {
        return {
          nickName: '',
          avatar: '',
          fullname: '',
          real_avatar: ''
        }
      }
    },
    createTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    circleId: {
      type: Number,
      default: 0
    },
    upCount: {
      type: Number,
      default: 0
    },
    isUp: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    thumbsUp (callback) {
      const promsie = post({
        url: `/call/isUp/${this.id}/${get('user').id}`,
        data: {
          isUp: !this.isUp
        }
      })
      promsie.then(res => {
        const { status } = res
        if (Object.is(status, 200)) {
          if (callback) {
            callback()
          }
          this.$emit('thumbsUp')
        }
      })
    }
  },
  computed: {
    getThumbUp () {
      return {
        idProp: this.isUp,
        url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        count: this.upCount,
        label: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content-item-message {
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  .avater {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .content-item-body {
    cursor: pointer;
    .content-item {
      display: flex;
      justify-content: space-between;
      h2 {
        font-size: 16px;
        font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      .content-item-right {
          display: flex;
          align-items: center;
          margin-right: 20px;
          img {
            width: 15px;
            height: 15px;
            margin-right: 8px;
          }
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
    }
    h5 {
      font-size: 11px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      line-height: 13px;
      margin-bottom: 7px;
    }
    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      width: 79.2vw;
      // text-overflow: ellipsis;
      // overflow: hidden;
      display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .parent {
      color: #888888;
    }
    .content-item-imgs {
      margin-bottom: 11px;
      img {
        width: 92px;
        height: 92px;
        margin-right: 4px;
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      align-items: center;
    }
  }
}
</style>
